export default __webpack_public_path__ + "static/media/extractores.71f8ab36.jpg";